import { Controller } from "@hotwired/stimulus"

// メディアサイト用クリックイベントトラッキングコントローラ
//
// CTA クリック、関連記事クリック等のユーザーアクションを
// dataLayer に push する。
export default class extends Controller {
  static values = {
    articleId: String,
    articleTitle: String,
    destination: String,
    sourceArticleId: String,
    targetArticleId: String,
    targetArticleTitle: String
  }

  trackCtaClick() {
    this.#push({
      event: "cta_click",
      article_id: this.articleIdValue,
      article_title: this.articleTitleValue,
      cta_destination: this.destinationValue
    })
  }

  trackRelatedArticleClick() {
    this.#push({
      event: "related_article_click",
      source_article_id: this.sourceArticleIdValue,
      target_article_id: this.targetArticleIdValue,
      target_article_title: this.targetArticleTitleValue
    })
  }

  // --- private ---

  #push(data) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }
}
